export default __webpack_public_path__ + "static/media/search.d01a2dea.svg";